import React from 'react';
import styled from 'styled-components';
import { colors, spacing } from '../../style';

type Type = React.HTMLProps<HTMLAnchorElement>;
export const MainContentA11ySkipAlert = styled(
  ({ text = 'Navigate to main content', ...props }: Type & { text?: React.ReactNode }) => {
    return (
      <a href={'#main-content'} {...props}>
        {text}
      </a>
    );
  },
)<Type>`
  background: ${colors.gray100};
  padding: ${spacing.xs};
  width: 100%;
  z-index: 9999;
  position: absolute;
  display: block;
  color: ${colors.gray900};
  text-align: center;
  font-weight: 500;
  left: 0;
  top: -200px;

  &:focus {
    top: 0;
    border: 1px solid ${props => props.theme.actionColor};
  }
`;

export default MainContentA11ySkipAlert;
